import { useArgusAuth } from "../../hooks/useArgusAuth";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { ApiCallStatus, PaymentType } from "../../utils/constants";
import { fetchPaymentOrderData } from "../PageFunctions/paymentFunctions";
import { Alert, Backdrop, CircularProgress, Container } from "@mui/material";
import PaymentEft from "../../components/PaymentEft";
import PaymentPayfast from "../../components/PaymentPayfast";


const PaymentPayfastPage = ({
	genericDataLoaded,
	genericPageContent
}) => {
	const {isAuthenticated, isLoading} = useArgusAuth();
	const location = useLocation();
	const navigate = useNavigate();
	const [paymentOrderInfo, setPaymentOrderInfo] = useState(null);
	const [paymentErrorMessage, setPaymentErrorMessage] = useState("");

	const [paymentOrderInfoCallStatus, setPaymentOrderInfoCallStatus] = useState(ApiCallStatus.NotStarted);

	const gotoLoginPage = () => navigate("/login", {state: {from: location}});

	const fetchPaymentOrderDataAsync = async () => {
		setPaymentErrorMessage("");
		await fetchPaymentOrderData({
			paymentType: PaymentType.PayFast,
			setPaymentOrderInfo,
			setStatusInProgress: () => setPaymentOrderInfoCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setPaymentOrderInfoCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setPaymentOrderInfoCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setPaymentOrderInfoCallStatus(ApiCallStatus.Error),
			setErrorMessage: setPaymentErrorMessage
		});
	};

	const authorizedPageLoad = async () => {

	};

	const unAuthorizedPageLoad = async () => {
		await fetchPaymentOrderDataAsync();
	};

	useEffect(() => {
		if (genericDataLoaded === true && isLoading === false) {
			if (isAuthenticated === false) {
				gotoLoginPage();
			} else {
				authorizedPageLoad();
				unAuthorizedPageLoad();
			}
		}
	}, [genericDataLoaded, isAuthenticated, isLoading]);

	useEffect(() => {
		// if (!!paymentErrorMessage) window.scrollTo(0, 0);
	}, [paymentErrorMessage]);

	const allLoadingStates = [
		paymentOrderInfoCallStatus
	];

	const pageIsLoading = allLoadingStates.includes(ApiCallStatus.InProgress) || genericDataLoaded === false || isLoading === true;

	return (
		<Container maxWidth="lg">
			{!!paymentErrorMessage && (
				<Alert severity="warning" sx={{mt: 2, mb: 2}}>
					{paymentErrorMessage}
				</Alert>
			)}
			<PaymentPayfast
				paymentOrderInfo={paymentOrderInfo}
			/>
			<Backdrop
				sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
				open={pageIsLoading}
			>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</Container>
	);
};

export default PaymentPayfastPage;